<template>
  <div class="flex gap-2">
    <p-button
      v-show="!emailVisible"
      color="secondary"
      icon="envelope"
      @click="onShowSendEmail"
    >{{ $tk("Reports.SendCopyOfInvoice") }}</p-button>
    <div v-show="emailVisible">
      <form
        class="flex gap-2 p-1 -m-1 bg-green-100 rounded"
        :disabled="sending"
        @submit.prevent="onSubmitEmail"
      >
        <div class="relative">
          <p-input
            v-model="invoiceEmail"
            :disabled="sending"
            :focus="emailVisible"
            class="w-48"
            iconInsideLeft="envelope"
            placeholder="E-post"
            type="email"
            @input="errorMessage = ''"
          />
          <div
            v-if="sending"
            class="absolute right-2 top-2"
          >
            <font-awesome-icon
              :icon="['far', 'spinner']"
              pulse
            />
          </div>
        </div>
        <p-button
          :disabled="invoiceEmail === '' || sending"
          color="primary"
          icon="envelope"
          type="submit"
        >{{
          $tk("Common.Actions.Send") }}</p-button>
        <p-button
          :disabled="sending"
          color="danger"
          icon=""
          @click="emailVisible = false"
        >{{ $tk("Common.Actions.Cancel")
          }}</p-button>
      </form>
      <div
        v-if="errorMessage"
        class="w-full mt-1 text-sm text-red-500"
      >{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
import http from "@/utilities/http"

export default {
  props: {
    invoiceId: { type: String, },
    invoiceIds: { type: Array, default: () => [] },
    docType: { type: String, default: "FAKTURA" }
  },
  data() {
    return {
      emailVisible: false,
      invoiceEmail: "",
      errorMessage: "",
      sending: false
    }
  },
  methods: {
    onShowSendEmail() {
      this.emailVisible = true;
      this.errorMessage = "";
    },
    async onSubmitEmail() {
      this.errorMessage = "";
      this.sending = true;

      try {
        const promises = [];

        if (this.invoiceId)
          promises.push(http.get("invoiceDocument", {
            params: {
              id: this.invoiceId,
              type: "FAKTURA",
              sendToEmail: this.invoiceEmail
            }
          }));

        if (this.invoiceIds.length > 0)
          for (let i = 0; i < this.invoiceIds.length; i++) {
            promises.push(http.get("invoiceDocument", {
              params: {
                id: this.invoiceIds[i],
                type: this.docType,
                sendToEmail: this.invoiceEmail
              }
            }));
          }

        await Promise.all(promises);
        this.emailVisible = false;
        this.invoiceEmail = "";
      } catch (error) {
        console.error("Error on submit email:", error);
        this.errorMessage = error.reason;
      } finally {
        this.sending = false;
      }
    }
  }
}

</script>